import { c as _c } from "react/compiler-runtime";
import { useFormikContext } from 'formik';
import debounce from 'lodash/debounce';
import isEqual from 'lodash/isEqual';
import { useCallback, useEffect, useMemo, useState } from 'react';
export function SubmitListener() {
  const $ = _c(11);
  const {
    submitForm,
    values,
    initialValues,
    isValid
  } = useFormikContext();
  const [lastValues, updateState] = useState(values);
  let t0;
  if ($[0] !== submitForm) {
    t0 = debounce(() => {
      submitForm();
    }, 500, {
      maxWait: 1500
    });
    $[0] = submitForm;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const debouncedSubmit = t0;
  let t1;
  if ($[2] !== debouncedSubmit) {
    t1 = () => {
      debouncedSubmit();
    };
    $[2] = debouncedSubmit;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleSubmit = t1;
  let t2;
  let t3;
  if ($[4] !== handleSubmit || $[5] !== initialValues || $[6] !== isValid || $[7] !== lastValues || $[8] !== values) {
    t2 = () => {
      const valuesEqualLastValues = isEqual(lastValues, values);
      const valuesEqualInitialValues = isEqual(values, initialValues);
      if (!valuesEqualLastValues) {
        updateState(values);
      }
      if (!valuesEqualLastValues && !valuesEqualInitialValues && isValid) {
        handleSubmit();
      }
    };
    t3 = [values, isValid, initialValues, lastValues, handleSubmit];
    $[4] = handleSubmit;
    $[5] = initialValues;
    $[6] = isValid;
    $[7] = lastValues;
    $[8] = values;
    $[9] = t2;
    $[10] = t3;
  } else {
    t2 = $[9];
    t3 = $[10];
  }
  useEffect(t2, t3);
  return null;
}